<template>
  <div id="app" class="calculator container">
    <div class="calculator__left">
      <router-view/>
    </div>
    <div class="calculator__right">
      <div class="summary">
        <div class="summary__title">
          Стоимость полиса:
        </div>
        <div class="summary__price">
          {{totalCost | numeric}} ₽
        </div>
        <app-input @input="checkPromo" class="calculator__promocode" :field.sync="promocode"  :input="schema.promocode" />
        <a v-if="$route.name == 'step4'" href="#" class="button button_width_full" :class="{disabled: buttonIsDisabled}"  @click.prevent="sendData">
          <span v-if="!isLoading">
            ОПЛАТИТЬ
          </span>
          <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
        </a>
        <a v-else href="#" class="button button_width_full"  @click.prevent="nextStep">
          <span v-if="!isLoading">
            Далее
          </span>
          <img v-else class="preloader" src="img/preloader-light-color.svg" alt="">
        </a>
      </div>
      <div class="summery-links">
        <a href="https://zettains.ru/upload/rules/Pravila_NS_FL.pdf" class="summery-links__link" target="_blank">
          Условия страхования
        </a>
        <a href="example_ns-sport.pdf" class="summery-links__link" target="_blank">
          Пример электронного полиса
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

</style>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import AppInput from '@/components/Input.vue'
  export default {
    components:{
      AppInput
    },
    created() {
      this.$router.replace('/')
    },
    data(){
      return {
        count:2

      }
    },
    methods:{
      checkPromo(){
        this.checkPromocode();
      },
      sendData(){
        this.$validator.validate().then(valid => {
          if (valid && !this.buttonIsDisabled && !this.isLoading) {
            this.$store.dispatch('sendData');
          }
        });
      },
      nextStep(){
        this.$children[0].$refs.buttonNext.click();

        // this.$validator.validateAll().then(valid => {
        //   if (valid) {
        //     this.$router.push({name:`step${this.count}`})
        //   }
        // });

      },
      ...mapActions([
          'checkPromocode'
      ])
    },
    computed:{
      ...mapFields([
        'isLoading',
        'promocode',
        'promocodeAmount',
      ]),
      ...mapGetters({
        schema: 'getSchema',
        getTotalCost: 'getTotalCost',
        selectedSports:'getSelectedSports',
        sportTariffs: 'getSportTariffs',
        sum:'getSum',
        sports:'getSelectedSports',
        term:'getTerm',
        peopleCount:'getCount',
        maxCategory:'getMaxCategory',
        buttonIsDisabled:'getButtonIsDisabled',
        mail:'getMail',
        phone:'getPhone',
        polisDate:'getPolisDate',
      }),
      totalCost(){
        const {sportTariffs, selectedSports, sum, sports, term, peopleCount, promocodeAmount} = this
        let category = 1;
        let cost = '';
        let discountValue = 0;
        if(selectedSports.length){
          selectedSports.forEach((el) => {
            if(parseInt(el.UF_CATEGORY) > category) {
              category = parseInt(el.UF_CATEGORY);
            }
          })
          cost = sportTariffs[sum.value][category][term.value].premium*peopleCount.value;
          discountValue = cost * promocodeAmount;
          const costWithDiscount = Math.floor(cost - discountValue);
          this.$store.commit('setTotalCost', cost)
          // this.$store.commit('setTotalCost', costWithDiscount)
          return costWithDiscount;
        }
      },
      buttonDisabled(){
        // if()
      }
    },
    watch:{

    }
  }
</script>

<style lang="scss">

  * {
    box-sizing:border-box;
  }
  .container {
    max-width: 1220px;
    margin:0 auto;
  }
  .calculator {
    display: flex;
    padding-left: 30px;
    padding-right: 5px;
    min-height: 200px;
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 65px;

    &__left {
      margin-right: 20px;
      width:calc(73% - 20px);
      padding-top: 30px;
      padding-right: 40px;
      border-right: 2px dotted #f2f2f2;
      padding-bottom: 30px;

    }
    &__right {
      width: 26%;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    &__promocode {
      margin-bottom: 10px;
    }
  }
  .summary {
    background: url('./assets/img/check.png') center center no-repeat;
    padding: 70px 35px 59px;
    min-height: 251px;
    background-size: contain;
    &__title {
      color:$primary;
      font-weight: 300;
      font-size: 27px;
    }
    &__price {
      padding: 20px 0;
      font-size: 52px;
      font-weight: 700;
      color:$primary;
      text-align: center;
    }
  }
  .summery-links {
    padding: 10px 16px 0;
    display: flex;
    justify-content:space-between;
    &__link {
      color:#808080;
      font-size: 10px;
    }
  }
  .preloader {
    height: 25px;
  }
</style>
